module.exports = __webpack_public_path__ + "static/media/teams-assessment-no-data.f2da0ba3.svg";